module.exports = __webpack_public_path__ + "static/elizabeth-warren-2dc7d58a8b947c8c6cf01737eced0db0.jpg";